import { memo } from 'react';
import { useSelector } from 'react-redux';

import Linkify from '~/components/Linkify';
import { ContentHeaderDescriptionContainer } from '~/components/PageHeader/ContentHeaderDescriptionContainer';
import { BOARD_BLURB_DESCRIPTION } from '~/constants/testIDs';
import { useExternalLinksClickableContext } from '~/providers/ExternalLinksClickableProvider';
import { centralizedBoardDescriptionSelector } from '~/store/centralizedBoard/selectors';

export const PublicBoardHeaderDescription = memo(() => {
  const description = useSelector(centralizedBoardDescriptionSelector);
  const { areExternalLinksClickable } = useExternalLinksClickableContext();

  if (!description) {
    return null;
  }

  return (
    <ContentHeaderDescriptionContainer className="mt-0.5">
      <Linkify disable={!areExternalLinksClickable}>
        <p
          data-testid={BOARD_BLURB_DESCRIPTION}
          data-disableselect="true"
          className="whitespace-pre-wrap break-words ads:text-metadata text-12 text-gray-10"
        >
          {description}
        </p>
      </Linkify>
    </ContentHeaderDescriptionContainer>
  );
});

PublicBoardHeaderDescription.displayName = 'PublicBoardHeaderDescription';
